import React from 'react';
import { Icon } from '../../../components/ui/Icon';

export default function FormActions({ isSubmitting, onCancel }) {
  return (
    <div className="flex flex-col sm:flex-row items-stretch sm:items-center justify-end space-y-3 sm:space-y-0 sm:space-x-4 pt-4 sm:pt-6">
      <button
        type="button"
        onClick={onCancel}
        disabled={isSubmitting}
        className="w-full sm:w-auto px-6 py-2.5 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 active:bg-gray-100 disabled:bg-gray-100 disabled:cursor-not-allowed transition-colors min-h-[44px] text-sm sm:text-base font-medium"
      >
        Annuler
      </button>
      <button
        type="submit"
        disabled={isSubmitting}
        className="w-full sm:w-auto flex items-center justify-center space-x-2 px-6 py-2.5 bg-green-600 text-white rounded-lg hover:bg-green-700 active:bg-green-800 disabled:bg-gray-400 disabled:cursor-not-allowed transition-colors shadow-sm min-h-[44px] text-sm sm:text-base font-medium"
      >
        {isSubmitting ? (
          <>
            <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white"></div>
            <span>Création en cours...</span>
          </>
        ) : (
          <>
            <Icon name="Check" size={18} />
            <span>Créer l'envoi</span>
          </>
        )}
      </button>
    </div>
  );
}